<template>
  <div v-html="hills + sun" />
</template>

<script setup lang="ts">
import hills from 'assets/homepage/background/hills.svg?raw'
import sun from 'assets/homepage/background/sun.svg?raw'
</script>

<style scoped>
div {
  left: 0;
  overflow: hidden;
  position: absolute;
  top: -17vw;
  width: 100vw;
  z-index: -1;
}

/* mobile landscape */
@media screen and (min-width: 320px) and (max-width: 998px) and (orientation: landscape) {
  div {
    top: -24vw;
  }
}

:deep(#sun) {
  left: 40%;
  position: relative;
  right: 0;
  top: -1.25em;
  width: 60%;
  z-index: -1;
}

:deep(#hills) {
  position: absolute;
  top: 25vw;
}
</style>
